// @core/api/endpoints/platform/decline_platform_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeclinePlatformInvitationRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Decline platform invitation
 * Declines a pending platform invitation. The invitation will be marked as declined and cannot be accepted afterward.
 */
export async function DeclinePlatformInvitation(
  invitation_id: string,
  data: DeclinePlatformInvitationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/invitations/:invitation_id/decline`;
  requestPath = requestPath.replace(':invitation_id', encodeURIComponent(invitation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
